const navBarContent = [
  { label: "HOME", path: "/" },
  { label: "ABOUT US", path: "/aboutus" },
  { label: "INSTRUCTOR", path: "/instructor" },
  { label: "GALLERY", path: "/gallery" },
];

export default navBarContent;
